const MONTH_NAMES = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "Mei",
  "Jun",
  "Jul",
  "Agu",
  "Sep",
  "Okt",
  "Nov",
  "Des"
];

export function parseLicenseDate(value) {
  const raw = String(value || "").trim();
  const match = /^(\d{4})-(\d{2})-(\d{2})(?:[T\s].*)?$/.exec(raw);
  if (!match) {
    return null;
  }

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(Date.UTC(year, month - 1, day));

  if (
    date.getUTCFullYear() !== year ||
    date.getUTCMonth() !== month - 1 ||
    date.getUTCDate() !== day
  ) {
    return null;
  }

  return date;
}

export function formatLicenseDate(value) {
  const date = parseLicenseDate(value);
  if (!date) {
    return "";
  }

  return (
    date.getUTCDate() +
    " " +
    MONTH_NAMES[date.getUTCMonth()] +
    " " +
    date.getUTCFullYear()
  );
}

export function getLicenseExpiryInfo(value, now) {
  const date = parseLicenseDate(value);
  if (!date) {
    return {
      state: "unknown",
      days: null,
      date: null,
      dateLabel: ""
    };
  }

  const current = now instanceof Date ? now : new Date();
  const todayUtc = Date.UTC(
    current.getFullYear(),
    current.getMonth(),
    current.getDate()
  );
  const expiryUtc = Date.UTC(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate()
  );
  const days = Math.round((expiryUtc - todayUtc) / 86400000);
  const dateLabel = formatLicenseDate(value);

  if (days >= 0 && days <= 7) {
    return {
      state: "warning",
      days: days,
      date: date,
      dateLabel: dateLabel
    };
  }

  if (days < 0 && days >= -15) {
    return {
      state: "expired",
      days: Math.abs(days),
      date: date,
      dateLabel: dateLabel
    };
  }

  return {
    state: "none",
    days: days,
    date: date,
    dateLabel: dateLabel
  };
}

export function formatDateRangeForMonth(dateValue) {
  const date = dateValue instanceof Date ? dateValue : new Date();
  const start = new Date(date.getFullYear(), date.getMonth(), 1);
  const end = new Date(date.getFullYear(), date.getMonth() + 1, 0);

  return (
    start.getDate() +
    " " +
    MONTH_NAMES[start.getMonth()] +
    " " +
    start.getFullYear() +
    " - " +
    end.getDate() +
    " " +
    MONTH_NAMES[end.getMonth()] +
    " " +
    end.getFullYear()
  );
}

export function formatLicenseDayLabel(info) {
  if (!info || info.days === null) {
    return "";
  }
  if (info.state === "warning") {
    return info.days === 0 ? "Berakhir hari ini" : info.days + " hari lagi";
  }
  if (info.state === "expired") {
    return "Sudah kedaluwarsa " + info.days + " hari";
  }
  return "";
}



// WEBPACK FOOTER //
// ./src/utils/licenseExpiry.js